import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../../utils/lazyImportRouteComponent"

type SearchParams = {
  fromAbsentApproval?: string
  personId: number
}

export const Route = createFileRoute(
  "/app/admin-settings/users/new/user-for-person"
)({
  component: lazyImportRouteComponent(
    () => import("./-components/NewUserForPersonPage"),
    "NewUserForPersonPage"
  ),
  validateSearch: (searchParams: SearchParams) => {
    if (searchParams.fromAbsentApproval) {
      return searchParams
    }
    return searchParams
  },
})
